function getColorsFromHash() {
    if (document.location.hash.length > 1) {
      return document.location.hash
        .substring(1)
        .split("-")
        .map((color) => "#" + color);
    }
    return [];
  }
  export default getColorsFromHash